import { PublicClientApplication } from '@azure/msal-browser';

import { MS_AUTHENTICATE } from '../utils/routes';

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENAT_ID}`,
    redirectUri: MS_AUTHENTICATE,
    post_logout_redirect_uri: MS_AUTHENTICATE,
    navigateToLoginRequestUrl: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
